var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  color: "currentColor",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.5 1.321 18.68 17.5 17.5 18.678l-3.297-3.297a7.2 7.2 0 0 1-3.37 1.242v1.71H9.168v-1.71c-2.961-.308-4.75-2.227-5.687-3.67l-.454-.699 1.398-.907.454.7C5.744 13.38 7.334 15 10 15c1.22 0 2.205-.336 3-.823l-1.236-1.235a4.167 4.167 0 0 1-5.93-3.776V7.012L1.322 2.5zM14.167 9.167c0 .442-.069.868-.197 1.268L6.756 3.218a4.167 4.167 0 0 1 7.412 2.614z"
})));
export default SvgMicOff;